import React from "react";
import VoucherBookingsTable from "../../components/VoucherBookingsTable";
import { Card, CardBody } from "reactstrap";

const Bookings = () => {
  return (
    <div>
      {/* Page Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="mb-0">
          <i className="bi bi-calendar-check me-2"></i>
          Voucher Bookings
        </h2>
      </div>

      {/* Table Card */}
      <Card>
        <CardBody>
          <VoucherBookingsTable />
        </CardBody>
      </Card>
    </div>
  );
};

export default Bookings;